import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Plus, Trash2 } from "lucide-react";
import { Input } from "@/components/ui/input";

export const RuleEditor = ({ cat, rule, onChange, testId }) => (
  <div className="flex items-center gap-2">
    <select value={rule.mode} onChange={(e) => onChange({ mode: e.target.value, value: e.target.value === "source" ? null : rule.value ?? 0 })}
      className="h-9 rounded-md border border-slate-200 bg-white px-2 text-sm" data-testid={`${testId}-mode`}>
      {cat.source && <option value="source">From file: {cat.source}</option>}
      {cat.kind === "count" && <option value="number">Number per store</option>}
      <option value="percent">{cat.kind === "rate" ? "Target %" : `% of ${cat.pctBase}`}</option>
    </select>
    {rule.mode !== "source" && (
      <div className="relative">
        <Input type="number" min="0" step="any" value={rule.value ?? ""} onChange={(e) => onChange({ mode: rule.mode, value: e.target.value })}
          className="w-28 h-9 pr-7" data-testid={`${testId}-value`} />
        <span className="absolute right-2.5 top-2 text-xs text-slate-400">{rule.mode === "percent" ? "%" : "#"}</span>
      </div>
    )}
  </div>
);

const storeName = (s) => `${s.location?.name?.replace("Total Wireless | ", "") || `${s.city}, ${s.state}`} · ${s.store_id}`;

export const OverridesEditor = ({ cat, rule, stores, onChange }) => {
  const [pick, setPick] = useState("");
  const overrides = rule.overrides || {};
  const byTsp = Object.fromEntries(stores.map((s) => [s.door_tsp, s]));
  const setOverrides = (o) => onChange({ overrides: o });
  const tid = `vz-quota-${cat.key}`;
  const add = () => {
    if (!pick) return;
    setOverrides({ ...overrides, [pick]: { mode: rule.mode, value: rule.value } });
    setPick("");
  };
  const remove = (tsp) => { const o = { ...overrides }; delete o[tsp]; setOverrides(o); };
  return (
    <div className="space-y-2 rounded-lg bg-slate-50 p-3" data-testid={`${tid}-overrides`}>
      {Object.entries(overrides).map(([tsp, o]) => (
        <div key={tsp} className="flex items-center gap-3 flex-wrap" data-testid={`${tid}-override-${tsp}`}>
          <span className="text-xs text-slate-600 min-w-[220px]">{byTsp[tsp] ? storeName(byTsp[tsp]) : `TSP ${tsp}`}</span>
          <RuleEditor cat={cat} rule={o} onChange={(p) => setOverrides({ ...overrides, [tsp]: { ...o, ...p } })} testId={`${tid}-override-${tsp}`} />
          <Button variant="ghost" size="icon" onClick={() => remove(tsp)} data-testid={`${tid}-override-${tsp}-remove`}><Trash2 className="w-4 h-4 text-red-500" /></Button>
        </div>
      ))}
      <div className="flex items-center gap-2">
        <select value={pick} onChange={(e) => setPick(e.target.value)} className="h-9 rounded-md border border-slate-200 bg-white px-2 text-sm max-w-xs" data-testid={`${tid}-override-store-select`}>
          <option value="">Choose a store…</option>
          {stores.filter((s) => !overrides[s.door_tsp]).map((s) => <option key={s.door_tsp} value={s.door_tsp}>{storeName(s)}</option>)}
        </select>
        <Button size="sm" variant="outline" onClick={add} disabled={!pick} data-testid={`${tid}-override-add`}><Plus className="w-4 h-4 mr-1" /> Add override</Button>
      </div>
    </div>
  );
};
